var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "alert-menu col-xs-12 p-0 m-0" },
      [
        _c("date-picker", {
          attrs: {
            "default-value": _vm.start_approval_date
              ? _vm.start_approval_date
              : new Date(),
            "disabled-date": _vm.notBeforeApprovalEndDate,
            editable: false,
            type: "date",
            placeholder: "DD-MM-YYYY",
            format: "DD-MM-YYYY",
            valueType: _vm.dateFormat,
          },
          on: {
            change: function ($event) {
              return _vm.onDateRangeSelection()
            },
          },
          model: {
            value: _vm.start_approval_date,
            callback: function ($$v) {
              _vm.start_approval_date = $$v
            },
            expression: "start_approval_date",
          },
        }),
        _c("div", { staticClass: "start-to-end" }, [_vm._v("to")]),
        _c("date-picker", {
          attrs: {
            "disabled-date": _vm.notBeforeApprovalStartDate,
            "default-value": _vm.end_approval_date
              ? _vm.end_approval_date
              : new Date(),
            editable: false,
            type: "date",
            placeholder: "DD-MM-YYYY",
            format: "DD-MM-YYYY",
            valueType: _vm.dateFormat,
          },
          on: {
            change: function ($event) {
              return _vm.onDateRangeSelection()
            },
          },
          model: {
            value: _vm.end_approval_date,
            callback: function ($$v) {
              _vm.end_approval_date = $$v
            },
            expression: "end_approval_date",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "font-weight-prop col-xs-12 p-0" }, [
      _c("div", { staticClass: "sub-approval" }, [_vm._v("Date Range")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }